import { useState } from 'react'
import { useView } from '@10000/react'
import { AddPill, Avatar, Body, Box, ItemPill, OrganisationDialog } from '../../widgets'

export const OrganisationSelect = ({ organisation, onOrganisationSelected, editable }) => {
  const { organisations } = useView('tenant')
  const { avatar, name } = organisation ? organisations.find(x => x.id === organisation) : { avatar: 0, name: '' }

  const [openOrganisationDialog, setOpenOrganisationDialog] = useState(false)

  return <Box gap={8} column>
    <Body alt bold>Organisation</Body>
    {organisation
      ? <ItemPill
          action={avatar === undefined}
          index={1}
          onClick={editable ? () => onOrganisationSelected(undefined) : undefined}
        >
          <Box fullWidth alignItems="center" gap={8}>
            <Avatar size="small" index={avatar} mode="company"/>
            <Box fullWidth>
              <Body bold align="left">{name}</Body>
            </Box>
            {editable && <Body underline alt bold size={12}>Remove</Body>}
          </Box>
        </ItemPill>
      : <AddPill text="Select" onClick={() => setOpenOrganisationDialog(true)}/>
    }
    <OrganisationDialog
      open={openOrganisationDialog}
      onSelected={onOrganisationSelected}
      onClose={() => setOpenOrganisationDialog(false)}
      showControls={false}
    />
  </Box>
}